import BaseService from './baseService';

class Item extends BaseService {
	async searchItem(filter,opts = {}) {
    this.endPoint = `/search-item?q=${filter.q}&type=${filter.type}`;
		return this.get(opts);
  }
  async getItems(opts = {}) {
    this.endPoint = '/items';
		return this.get(opts);
  }
  async getItemsUnique(opts = {}) {
    this.endPoint = '/getItemsUnique';
		return this.get(opts);
  }
  async getUserItems(page,opts = {}) {
    this.endPoint = '/items-user?jum='+ page.jum+ '&page='+ page.page;
		return this.get(opts);
  }

  async searchItemWithDate(payload) {
    this.endPoint = '/items/searchItemWithDate';
    return await this.post(payload);
  }
}

export default new Item();